import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { useAuth } from "contexts/AuthContext";

import StandardButton from "components/Common/buttons/StandardButton";
import { generateReportUrl } from "utils/report.utils";

type ItemProps = {
  subs: any;
  remove: Function;
};

const SurveySummary: React.FC<ItemProps> = ({ subs, remove }) => {
  return subs.map((sub, index) =>
    <Item key={`Survey_SubscriptionsItem_${sub.survey_id}_${index}`} sub={sub} remove={remove} />
  );
};

const Item = ({ sub, remove }) => {
  const { isSales } = useAuth();

  const [keep, setKeep] = useState<boolean>(false);
  const [date, setDate] = useState("N/A");

  const url = generateReportUrl(sub.survey_name);

  useEffect(() => {
    if (sub.date_added) {
      setDate(new Date(sub.date_added).toString());
    }
  }, []);

  function handleClick() {
    setKeep(!keep);
    remove(sub.survey_id);
  }

  if (isSales()) {
    return (
      <SubscriptionsItem $keep={keep}>
        <div>
          <Link
            to={`/medsku/dashboard/${sub.survey_id}/${url}`}
            target="_blank"
          >
            {sub.survey_name}
          </Link>
          <Access>Access assigned on: {date}</Access>
        </div>

      </SubscriptionsItem>
    );
  } else {
    return (
      <SubscriptionsItem $keep={keep}>
        <div>
          <Link
            to={`/medsku/dashboard/${sub.survey_id}/${url}`}
            target="_blank"
          >
            {sub.survey_name}
          </Link>
          <Access>Access assigned on: {date}</Access>
        </div>

        <StandardButton onClick={handleClick} size="xs" type={"button"}>
          {keep ? "Keep" : "Remove"}
        </StandardButton>
      </SubscriptionsItem>
    );
  }

}

const SubscriptionsItem = styled.div<{ $keep?: boolean; }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  padding: 1rem;

  div {
    width: 100%;
  }

  opacity: ${props => props.$keep ? 0.5 : 1};
  transition: 0.2s;
`;

const Access = styled.div`
  font-size: 1.5rem;
`;

export default SurveySummary;
